function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Swiper from 'swiper/bundle';
function upsellSwiper() {
  var swiperUpsell = new Swiper('.upsell-content', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true
    },
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom"
    }
  });
}
function atcProductUpsell() {
  $("input.variant-color-input[type=\"checkbox\"]").on('click', function () {
    var $variant = $(this);
    if ($variant.is(":checked")) {
      var group = "input.variant-color-input[name='" + $variant.attr("name") + "']";
      $(group).prop("checked", false);
      $variant.prop("checked", true);
    } else {
      $variant.prop("checked", true);
    }

    // Send variant id of selected color
    $("#atc-" + $variant.attr("name")).prop("href", "/cart/add?id=" + $variant.attr("value") + "&quantity=1");

    // Show selected variant
    var imgGroup = "img.img-" + $variant.attr("name");
    $(imgGroup).prop("style", "display: none");
    $("#img-" + $variant.attr("id")).prop("style", "display: block");

    // Disable atc for sold out variants
    if ($variant.attr("available") === "true") {
      $("#atc-div-" + $variant.attr("name")).addClass("atc-upsell-product-container__available").removeClass("atc-upsell-product-container__unavailable");
    } else {
      $("#atc-div-" + $variant.attr("name")).addClass("atc-upsell-product-container__unavailable").removeClass("atc-upsell-product-container__available");
    }
  });
}
var observeDOMChanges = function observeDOMChanges(element) {
  var observer = new MutationObserver(function (mutationsList) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.previousSibling.className === "cart-drawer") {
          //console.log("Recargando funciones!!");
          observer.disconnect();
          upsellSwiper();
          atcProductUpsell();
          connectObserver();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  var config = {
    attributes: true,
    childList: true,
    subtree: false
  };
  observer.observe(element, config);
};
function connectObserver() {
  var targetElement = document.querySelector('#shopify-section-cart-drawer');
  var targetElementB = document.querySelector('#shopify-section-cart-drawer-b');
  var targetElementC = document.querySelector('#shopify-section-cart-drawer-c');
  if (targetElement) {
    observeDOMChanges(targetElement);
  }
  if (targetElementB) {
    observeDOMChanges(targetElementB);
  }
  if (targetElementC) {
    observeDOMChanges(targetElementC);
  }
}
function runCartDrawerUpsell() {
  if (window.getComputedStyle(document.querySelector("#cart-drawer--upsell-ab")).display != "none") {
    upsellSwiper();
    atcProductUpsell();
    connectObserver();
  }
}
export default runCartDrawerUpsell;